var Raven = require('../Raven');
var React = require('react');
var moment = require('moment');

var robot = require('../images/error-robot-2.png');

var Error = React.createClass({
    render: function () {
        var eventId = Raven.lastEventId() || "Unknown";

        return <div className="standalone-page-wrapper">
            <div className="error-top-block">
              <div className="error-top-block-image"> <img src={robot} alt="Ooops!" /> </div>
            </div>

            <div className="error-bottom-block">
              <div className="col-md-6 col-md-offset-3 error-description">
                <div className="error-code">Uhoh</div>
                <div className="error-meaning">An unknown error occurred.</div>
                <div className="todo">
                  <h4>It is not you. It is us. We are sorry.</h4>
                  <p>We are experiencing an internal server error — something went terribly wrong. You can try refreshing the page, the problem may be temporary.</p>
                  <p>Raven report: {eventId}</p>
                </div>
                <div className="copyrights"> &copy; Infinite Networks Pty Ltd {moment().format('YYYY')}</div>
              </div>
            </div>
        </div>;
    }
})
module.exports = Error;



// WEBPACK FOOTER //
// ./app/components/Error.js